export const PATIENT_APPOINTMENTS_PATH =
  "/{tenantId}/patients/{patientId}/appointments" as const;

export function buildPatientAppointmentsRequest({
  tenantId,
  patientId,
  startDate,
  endDate,
}: {
  tenantId: string;
  patientId: string;
  startDate?: string;
  endDate?: string;
}) {
  return {
    path: PATIENT_APPOINTMENTS_PATH,
    options: {
      params: {
        path: { tenantId, patientId },
        query: {
          startDate: startDate ?? undefined,
          endDate: endDate ?? undefined,
          sort: "asc" as const,
        },
      },
    },
  } as const;
}
